import classNames from 'classnames'

import { RCTooltip } from 'components/RCTooltip'
import { useTranslate } from 'lib/tolgee'
import { TOLGEE_GLOBALS } from 'utils'

import TOLGEE_KEYS from './translate'

import './index.scss'

type ChipStatusProps = {
  status: 'done' | 'draft' | 'zai'
  size: 'large' | 'small'
  className?: string
}

const getTooltipKey = status => {
  switch (status) {
    case 'zai':
      return TOLGEE_KEYS.tooltipZai
    case 'done':
      return TOLGEE_KEYS.tooltipDone
    case 'draft':
      return TOLGEE_KEYS.tooltipDraft
    default:
      return TOLGEE_KEYS.tooltipDraft
  }
}

export function ChipStatus({ status, size, className }: ChipStatusProps) {
  const t = useTranslate()

  return (
    <div data-testid="chip-status">
      <RCTooltip tooltipMessage={t(getTooltipKey(status))}>
        <div className={classNames('chip-status', status, size, className)}>{t(TOLGEE_GLOBALS[status])}</div>
      </RCTooltip>
    </div>
  )
}
